const INSTRUCTIONS_SERVICE = 'https://instructions.documents.cimpress.io';
export function getInstructionsServiceUrl() {
    return `${INSTRUCTIONS_SERVICE}/v3/instructions:preview`;
}
export function getItemInstructionsServiceUrl() {
    return `${INSTRUCTIONS_SERVICE}/v3/instructions:item`;
}
export function buildInstructionsUrl({ cimDocUrl, surfaceOrdinals, ignoreProjection, instructionsServiceUrl = getInstructionsServiceUrl(), }) {
    const url = new URL(instructionsServiceUrl);
    url.searchParams.set('documentUri', cimDocUrl);
    if (surfaceOrdinals) {
        url.searchParams.set('surfaceOrdinals', `${surfaceOrdinals}`);
    }
    if (ignoreProjection) {
        url.searchParams.set('ignoreProjection', `${ignoreProjection}`);
    }
    return url.toString();
}
//# sourceMappingURL=instructionsUrl.js.map